/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../core/AppDispatcher'
import Immutable from 'immutable'
import LoginEvent from '../event/LoginEvent'

const Login = Immutable.Record({
  email: '',
  password: '',
  message: '',
  referrer: '/'
})

class LoginStore extends ReduceStore<State, Action> {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new Login()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case LoginEvent.initialized:
        return state.set(payload.name, payload.value)
      case LoginEvent.failed:
        return state.set('message', 'メールアドレスもしくはパスワードが正しくありません。入力し直してください。[パスワードをお忘れですか] をクリックすると、再設定できます。')
      case LoginEvent.updateReferrer:
        return state.merge({ referrer: payload.path })
      case LoginEvent.onChange:
        return state.set(payload.name, payload.value)
      case LoginEvent.logoutSuccess:
        return state.merge({ email: '', password: '' })
      default:
        return state
    }
  }
}

export default new LoginStore()
